// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"12":"0ec18c85285b66371627","584":"e6e13e4c172e5c9f9e3c","777":"37f5b4c689f9b1efca7c","880":"ef35163d0d2afef4a61e"}[chunkId] + ".js";
};